import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {validateClassCodeForSignupType} from "./__graphql-types__/index.ts";

export type {validateClassCodeForSignupType};

/**
 * Query to validate a class code during U13 signup flow.
 * Returns public classroom info to verify the class code is valid.
 */
export const VALIDATE_CLASS_CODE_QUERY: GqlOperation<
    validateClassCodeForSignupType["response"],
    validateClassCodeForSignupType["variables"]
> = gqlOp(gql`
    query validateClassCodeForSignup($classCode: String!) {
        joinByClassCodeInfoV2(classCode: $classCode) {
            cacheId
            name
        }
    }
`);
